module.exports = __webpack_public_path__ + "media/images/cc_logos/paypal-0fba6fe34391d505fb70eadc684596ce.png";